import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DattaConfig} from '../app-config';
import { Tiepcongdan } from '../model/quanlythongtin/tiepcongdan';
import { Quanlylichhop } from '../model/quanlythongtin/quanlylichhop';
import { Hoidap } from '../model/quanlythongtin/hoidap';

@Injectable({
  providedIn: 'root'
})
export class TiepcongdanService {
  public dattaConfig: any;
  token: string;

  httpOptions: any;
  constructor(private httpClient: HttpClient) {
    this.dattaConfig = DattaConfig.config;    
  }
  
  ngOnInit(): void {
  
  }

  //start Tiepcongdan
  getTiepcongdans() {
    return this.httpClient.get<Tiepcongdan[]>(this.dattaConfig['httplink'] + '/tiepcongdan');
  }

  getTiepcongdanTheodonvis(id) {
    return this.httpClient.get<Tiepcongdan[]>(this.dattaConfig['httplink'] + '/tiepcongdan/'+ id);
  }

  addTiepcongdan(entity: Tiepcongdan) {
    return this.httpClient.post<Tiepcongdan>(this.dattaConfig['httplink'] + '/tiepcongdan/add', entity);
  }

  updateTiepcongdan(entity: Tiepcongdan){
    return this.httpClient.put<Tiepcongdan>(this.dattaConfig['httplink'] + '/tiepcongdan/update', entity);
  }

  deleteTiepcongdan(id) {
    return this.httpClient.delete<Tiepcongdan>(this.dattaConfig['httplink'] + '/tiepcongdan/'+id);
  }
  //end Tiepcongdan

  //start lich hop
  getQuanlylichhops() {
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + '/quanlylichhop');
  }

  searchQuanlylichhops(params: any) {
    let pars = { params };
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + `/quanlylichhop/lichhop`, pars);
  }
  getQuanlylichhopTheodonvis(id) {
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + '/quanlylichhop/get/'+id);
  }

  getLoaiQuanlylichhops(type) {
    return this.httpClient.get<Quanlylichhop[]>(this.dattaConfig['httplink'] + `/quanlylichhop/${type}`);
  }

  addQuanlylichhop(entity: Quanlylichhop) {
    return this.httpClient.post<Quanlylichhop>(this.dattaConfig['httplink'] + '/quanlylichhop/add', entity);
  }

  updateQuanlylichhop(entity: Quanlylichhop){
    return this.httpClient.put<Quanlylichhop>(this.dattaConfig['httplink'] + '/quanlylichhop/update', entity);
  }

  deleteQuanlylichhop(id) {
    return this.httpClient.delete<Quanlylichhop>(this.dattaConfig['httplink'] + '/quanlylichhop/'+id);
  }
  //end lichhop

  //start hoi dap
  getHoidaps() {
    return this.httpClient.get<Hoidap[]>(this.dattaConfig['httplink'] + '/hoidap');
  }
  
  getHoidapTheodonvis(id) {
    return this.httpClient.get<Hoidap[]>(this.dattaConfig['httplink'] + '/hoidap/'+id);
  }

  addHoidap(entity: Hoidap) {
    return this.httpClient.post<Hoidap>(this.dattaConfig['httplink'] + '/hoidap/add', entity);
  }

  updateHoidap(entity: Hoidap){
    return this.httpClient.put<Hoidap>(this.dattaConfig['httplink'] + '/hoidap/update', entity);
  }

  deleteHoidap(id) {
    return this.httpClient.delete<Hoidap>(this.dattaConfig['httplink'] + '/hoidap/'+id);
  }

  updateread(id: number) {
    return this.httpClient.get(this.dattaConfig['httplink'] + `/hoidap/updateread/${id}`);
  }
  //end hoi dap  
}